import React, { useState } from "react";

import { Radio } from "clearsense-ui/components";

import ExistingDestination from "./Existing";
import AddDestination from "./New";

import Replication from "../../Replication";

const Destination = ({
  setSelectedDestination,
  destinations,
  setLoading,
  setIsPathReady,
  isPathReady,
  replication,
  setReplication,
}) => {
  const [existingOrNew, setExistingOrNew] = useState("new");

  const handleDestinationSubmit = async values => {
    setSelectedDestination(values.existingDestination.value);
    setIsPathReady(true);
  };

  return (
    <>
      <Radio stacked className="space-y-4">
        <Radio.Item
          onChange={() => {
            setExistingOrNew("existing");
            setIsPathReady(false);
          }}
          checked={existingOrNew === "existing"}
          label="Choose from existing targets"
          value="existing"
          name="application"
          data-cy="add-existing-target-radio"
        />
        <Radio.Item
          onChange={() => {
            setExistingOrNew("new");
            setIsPathReady(false);
          }}
          checked={existingOrNew === "new"}
          label="Create a new target"
          value="new"
          name="application"
          data-cy="add-new-target-radio"
        />
      </Radio>
      {existingOrNew === "existing" ? (
        <ExistingDestination
          handleDestinationSubmit={handleDestinationSubmit}
          destinations={destinations}
          isPathReady={isPathReady}
        />
      ) : (
        <AddDestination
          setLoading={setLoading}
          setSelectedDestination={setSelectedDestination}
          setIsPathReady={setIsPathReady}
          isPathReady={isPathReady}
        />
      )}
      {isPathReady && (
        <Replication
          replication={replication}
          setReplication={setReplication}
        />
      )}
    </>
  );
};

export default Destination;
